// Collapses "MMMM d - MMMM d" into a single date when start === end (or end is empty).
export function getFormattedRange(value = '') {
  const dates = value?.split('-');
  const startDate = dates?.[0]?.trim() || '';
  const endDate = dates?.[1]?.trim() || '';

  const showOnlyStartDate = !endDate || startDate === endDate;

  return showOnlyStartDate ? startDate : value;
}
